<template>
  <w-icon-wrapper
    :width="23.4"
    :height="24"
    icon-name="work-planning-icon"
    viewBox="0 0 23.4 24"
  >
    <g
      id="_79_Planung_Icon"
      data-name="79 Planung_Icon"
      transform="translate(-3 -1)"
    >
      <g
        id="Gruppe_25613"
        data-name="Gruppe 25613"
        transform="translate(3 1)"
      >
        <path
          id="Pfad_55812"
          data-name="Pfad 55812"
          d="M5.433,5.8H7.867V9.4H20.033V5.8h2.433v6H24.9v-6a2.424,2.424,0,0,0-2.433-2.4H17.381a3.652,3.652,0,0,0-6.862,0H5.433A2.424,2.424,0,0,0,3,5.8V22.6A2.424,2.424,0,0,0,5.433,25h7.3V22.6h-7.3ZM13.95,3.4a1.2,1.2,0,1,1-1.217,1.2A1.212,1.212,0,0,1,13.95,3.4Z"
          transform="translate(-3 -1)"
          fill="currentColor"
        />
        <path
          id="Pfad_55813"
          data-name="Pfad 55813"
          d="M21,11.5,15.51,17,12.5,14,11,15.5,15.51,20l6.99-7Z"
          transform="translate(0.9 3)"
          fill="currentColor"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconPlanning' };
</script>
